import { render, staticRenderFns } from "./ProductsSectionTemplate.vue?vue&type=template&id=7e38a3e1&scoped=true&"
import script from "./ProductsSectionTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductsSectionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSectionTemplate.vue?vue&type=style&index=0&id=7e38a3e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e38a3e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
